import { Text, View } from "../Base";

import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import { memo } from "react";
import { palette } from "../../theme/palette";

const useStyles = makeStyles({
  text: {
    fontSize: "12px",
    color: palette.typography.white.high,
    lineHeight: "16px",
  },
  inline: {
    display: "flex",
    flexDirection: "row",
    marginTop: "4px",
  },
  center: {
    display: "flex",
    alignItems: "center",
  },
  bold: {
    fontWeight: 500,
  },
  whiteMedium: {
    color: palette.typography.white.medium,
  },
  hidden: {
    visibility: "hidden",
  },
  visible: {
    visibility: "visible",
  },
});

export const TextIconInfo = memo(({ keyName, value, icon, hide }) => {
  const styles = useStyles();

  return (
    <View
      className={clsx(
        styles.text,
        styles.inline,
        styles.center,
        hide ? styles.hidden : styles.visible
      )}
    >
      <Text className={styles.text}>
        <span className={styles.bold}>{keyName} </span>
        <span className={styles.whiteMedium}>{value}</span>
      </Text>
      {icon}
    </View>
  );
});
